import React, {useEffect} from 'react';
import ActionRequiredGrid from '../../../features/dealer/action-required-grid/components/ActionRequiredGrid';
import {useParams, useSearchParams} from "react-router-dom";
import {useTitle} from "../../../contexts/title";
import {useGetActionsRequired} from '../../../api/ar';

export default function ActionRequiredOrdersPage() {
	const pageTitle = useTitle();
	const params = useParams();
	const [searchParams] = useSearchParams();
	const actionRequiredID = parseInt(params.actionRequiredID!);
	const actionsRequired = useGetActionsRequired();
	const pastDueOnly = searchParams.get("pastDue") === "true"
	const activeOnly = searchParams.get("active") === "true"

	useEffect(() => {
		if (actionsRequired.data) {

			let title = actionsRequired.data.find(ar => ar.actionRequiredID === actionRequiredID)?.description ?? '';

			if (pastDueOnly)
				title += " (Past Due Orders)";
			else if (activeOnly)
				title += " (Active Orders)";

			pageTitle.setTitle(title);
		}
	}, [actionsRequired.data, pageTitle, actionRequiredID, activeOnly, pastDueOnly]);

	return (
		<React.Fragment>
			<div className={'content-block'}>
				<ActionRequiredGrid
					actionRequiredID={actionRequiredID}
					pastDueOnly={pastDueOnly}
					activeOnly={activeOnly}
				/>
			</div>
		</React.Fragment>
	)
} 
